export default function useMetaTag(meta){

    const metaTitle = document.querySelector('meta[name="Title"]');
    const metaDescripcion = document.querySelector('meta[name="Description"]');
    const metaKeywords = document.querySelector('meta[name="Keywords"]');


    if(meta.Title === undefined){
        metaTitle.setAttribute('content', "Intelaf - Te rodeamos de Computadoras, Laptops, Tablets, Celulares, Camaras Digitales, Smartphones, Notebooks y mas en Guatemala");
    }else{
        metaTitle.setAttribute('content', meta.Title + " Guatemala - Intelaf");
    }

    if(meta.Description === undefined){
        metaDescripcion.setAttribute('content', "Te rodeamos de Tecnologia en Guatemala desde 1989 Computadoras, Laptops, Tablets, Celulares, Smartphones, Notebooks, Netbooks y mucho mas");
    }else{
        metaDescripcion.setAttribute('content', meta.Description);
    }

    if(meta.Keywords === undefined){
        metaKeywords.setAttribute('content', "Intelaf, Guatemala, computadora, notebook, impresora, scanner, camara, webcams, monitor, memoria, disco duro, teclado, modem, red, router, Canon, HP, Genius, Manhattan, Trendnet, Toshiba, Samsung, tablet,smartphone,phone,cell,celular");
    }else{
        metaKeywords.setAttribute('content', meta.Keywords);
    }

    if(meta.OgTag===true){

        const ogMetaTitle       = document.querySelector('meta[name="og:title"]');
        const ogMetaUrl         = document.querySelector('meta[name="og:url"]');
        const ogMetaImage       = document.querySelector('meta[name="og:image"]');

        const ogMetaLocale       = document.querySelector('meta[name="og:locale"]');

        if(ogMetaTitle){
            ogMetaTitle.setAttribute('content', meta.Title);
            ogMetaUrl.setAttribute('content', "https://www.intelaf.com/precios_stock_detallado/"+meta.Codigo.toLowerCase());
            ogMetaImage.setAttribute('content', "https://www.intelaf.com/images/productos/gran/"+meta.Codigo+".jpg");
            ogMetaLocale.setAttribute('content', "es_GT");
        }else{
            const nuevoTitle = document.createElement('meta');
            nuevoTitle.name = 'og:title';
            nuevoTitle.content = meta.Title;

            const nuevaUrl = document.createElement('meta');
            nuevaUrl.name = 'og:url';
            nuevaUrl.content = "https://www.intelaf.com/precios_stock_detallado/"+meta.Codigo.toLowerCase();

            const nuevaImagen = document.createElement('meta');
            nuevaImagen.name = 'og:image'; 
            nuevaImagen.content = "https://www.intelaf.com/images/productos/gran/"+meta.Codigo+".jpg";

            const nuevoLocale = document.createElement('meta');
            nuevoLocale.name = 'og:locale'; 
            nuevoLocale.content = "es_GT";

            document.head.appendChild(nuevoTitle);
            document.head.appendChild(nuevaUrl);
            document.head.appendChild(nuevaImagen);
            document.head.appendChild(nuevoLocale);

            
        }

    }else{
        const ogMetaTitle       = document.querySelector('meta[name="og:title"]');
        const ogMetaUrl         = document.querySelector('meta[name="og:url"]');
        const ogMetaImage       = document.querySelector('meta[name="og:image"]');
        const ogMetaLocale      = document.querySelector('meta[name="og:locale"]');
        if(ogMetaTitle){
            ogMetaTitle.remove();
            ogMetaUrl.remove();
            ogMetaImage.remove();
            ogMetaLocale.remove();
        }
    }
    
}